import React from 'react';
import './LeaveConfirmModal.css';

const LeaveConfirmModal = ({ isOpen, onStay, onLeave }) => {
  if (!isOpen) return null;

  return (
    <div className="leave-confirm-overlay">
      <div className="leave-confirm-content">
        <div className="leave-confirm-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </div>
        <h2>Leave this page?</h2>
        <p>
          AI is still processing your request. If you leave now, the process will be interrupted and
          any results may be lost.
        </p>
        <div className="leave-confirm-actions">
          <button className="btn-stay" onClick={onStay}>
            <i className="fas fa-arrow-left"></i> Stay on Page
          </button>
          <button className="btn-leave" onClick={onLeave}>
            Leave Anyway <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveConfirmModal;
